import { ActionTypes } from "./types";

const {
  SET_RETENTIONS,
  SET_FILTERS,
  CLEAR_RETENTIONS,
  RESTORE_INITIAL,
  ADD_RETENTION,
  UPDATE_RETENTION_STATUS,
  REMOVE_RETENTION,
  SET_RETENTION_DETAILS,
  SET_RETENTION_BALANCE,
} = ActionTypes;

const currentMonth = new Date().getMonth() + 1;
const currentYear = new Date().getFullYear();

const INITIAL_STATE = {
  retentions: [],
  retentionDetails: [],
  retentionBalance: null,
  station: null,
  month: currentMonth,
  year: currentYear,
};

export const wholesalerRetentionsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_RETENTIONS:
      return { ...state, retentions: payload };

    case ADD_RETENTION:
      return { ...state, retentions: [payload, ...state.retentions] };

    case UPDATE_RETENTION_STATUS:
      return {
        ...state,
        retentions: state.retentions.map((r) =>
          r.id === payload.id ? { ...r, status: payload.status } : r
        ),
      };

    case REMOVE_RETENTION:
      return {
        ...state,
        retentions: state.retentions.filter((r) => r.id !== payload),
      };

    case SET_FILTERS: {
      let retentions = state.retentions;
      if (payload.key === "station") retentions = [];
      return { ...state, [payload.key]: payload.value, retentions };
    }

    case CLEAR_RETENTIONS:
      return { ...state, retentions: [] };

    case SET_RETENTION_DETAILS:
      return { ...state, retentionDetails: payload };

    case SET_RETENTION_BALANCE:
      return { ...state, retentionBalance: payload };

    case RESTORE_INITIAL:
    case "CLOSE_SESSION_LOGIN":
      return INITIAL_STATE;

    default:
      return state;
  }
};
